import { render, staticRenderFns } from "./travelForm.vue?vue&type=template&id=7bb72c11&scoped=true&"
import script from "./travelForm.vue?vue&type=script&lang=js&"
export * from "./travelForm.vue?vue&type=script&lang=js&"
import style0 from "./travelForm.vue?vue&type=style&index=0&id=7bb72c11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb72c11",
  null
  
)

export default component.exports